import { Stack, styled } from "@mui/material";

export const AssignTellerManagementWrapper = styled(Stack)(() => {
    return {
        gap: "var(--flex-gap)",
        overflow: "hidden",
        "& .assign-teller-management-table-box": {
            "& .MuiTableContainer-root": {
                borderRadius: "16px",
                "& .MuiTableHead-root": {
                    "& .MuiTableCell-root": {
                        whiteSpace: "nowrap",
                    },
                    "& .MuiTableCell-root:last-child": {
                        width: "25%",
                    }
                }
            },
        },
    }
})